module.exports = __webpack_public_path__ + "static/media/coffee_machine.eb51aeb6.svg";